import { render, staticRenderFns } from "./settled.vue?vue&type=template&id=4c4283be&scoped=true"
import script from "./settled.vue?vue&type=script&lang=js"
export * from "./settled.vue?vue&type=script&lang=js"
import style0 from "./settled.vue?vue&type=style&index=0&id=4c4283be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4283be",
  null
  
)

export default component.exports